import { useContext, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import Label from './Label';
import { CommonWrapper } from './styles';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';

export default function BedLength({ className }: WithClassName) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();
  const [expand, setExpand] = useExpand(false);

  const show =
    facetData.truckBedLengths?.buckets &&
    facetData.truckBedLengths?.buckets?.length > 0;

  useEffect(() => {
    if (!show) setExpand(false);
  }, [setExpand, show]);

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-bed-length"
        facetContent={facetData.truckBedLengths?.buckets}
        facetName="Bed Length"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <CommonWrapper>
          {facetData.truckBedLengths?.buckets?.map(({ key, displayName }) => (
            <Checkbox
              facet="truckBedLengths"
              filter={key}
              id={`bed-length-${displayName}`}
              key={displayName}
              label={<Label displayName={displayName} />}
              checked={appliedFilters?.truckBedLengths?.some(
                length => length === key
              )}
              onChange={() =>
                updateListFilter({
                  filterKey: 'truckBedLengths',
                  value: key
                })
              }
            />
          ))}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}
